import { DummyStore } from 'stores';

import { ReportsResponse } from '../types/report-response.type';
import { Report } from '../types/report.type';

export namespace ReportsStore {
  export const reports = new DummyStore<ReportsResponse>();
}
